module.exports = __webpack_public_path__ + "img/COPPA_300.158359eb.png";